<div class="payment-transaction-item">
  <div class="data-cell-contents-wrapper">
    <div
      *ngFor="let data of paymentTransactionData"
      class="data-cell {{ data.customClass }}"
      [ngClass]="{ 'single-line': !data.truncateThreshold }"
      [attr.data-e2e-id]="data.e2eId"
      [attr.data-e2e-value]="data.e2eValue"
    >
      <span
        *ngFor="let dataValue of data.values"
        class="data-cell-contents"
        [multiLineTruncate]="data.truncateThreshold"
        [ngSwitch]="dataValue.isHtml"
        ><ng-container *ngSwitchCase="true"
          ><span
            [innerHTML]="dataValue.value | safe: 'html'"
          ></span></ng-container
        ><ng-container *ngSwitchDefault>{{
          dataValue.value
        }}</ng-container></span
      >
    </div>
  </div>

  <app-dropdown
    class="actions"
    [horizontalAlignment]="DropdownHorizontalAlignmentsEnum.right"
    [dropdownGroupedItems]="paymentTransactionActions"
    [stopClickPropagation]="true"
    e2eId="transaction-history-list-item-dropdown"
  >
    <ng-template let-closeCallback="closeCallback" let-action="dropdownItem">
      <button
        type="button"
        class="action {{ action.customClass }}"
        [ngClass]="{ 'delete-action': action.deleteAction }"
        [attr.data-e2e-id]="action.e2eId"
        trackable
        [trackingObject]="action.trackingObject"
        [trackingAction]="action.trackingAction"
        [trackingAdditionalProperties]="action.trackingAdditionalProperties"
        (click)="onQuickAction(action); closeCallback()"
      >
        {{ action.label }}
      </button>
    </ng-template>
  </app-dropdown>
</div>

<div
  *ngIf="paymentTransactionNotes"
  class="transaction-note-wrapper data-cell-contents"
>
  {{ paymentTransactionNotes }}
</div>

<app-confirm-dialog
  [dialogId]="refundConfirmDialogId"
  [yesText]="'ACTION.REFUND' | translate"
  [cancelText]="'ACTION.KEEP' | translate"
  [confirmTitle]="'DIALOG.REFUND_TRANSACTION.CONFIRM_TITLE' | translate"
  [confirmPrompt]="'DIALOG.REFUND_TRANSACTION.CONFIRM_PROMPT' | translate"
  [isDeleteAction]="true"
  (onClose)="onRefund($event)"
>
</app-confirm-dialog>

<app-confirm-dialog
  [dialogId]="deleteConfirmDialogId"
  [yesText]="'ACTION.DELETE' | translate"
  [cancelText]="'ACTION.KEEP' | translate"
  [confirmTitle]="'DIALOG.DELETE_TRANSACTION.CONFIRM_TITLE' | translate"
  [confirmPrompt]="'DIALOG.DELETE_TRANSACTION.CONFIRM_PROMPT' | translate"
  [isDeleteAction]="true"
  (onClose)="onDelete($event)"
>
</app-confirm-dialog>

<app-confirm-dialog
  [dialogId]="unmatchConfirmDialogId"
  [yesText]="'ACTION.UNDO' | translate"
  [cancelText]="'ACTION.KEEP' | translate"
  [confirmTitle]="'DIALOG.UNMATCH_TRANSACTION.CONFIRM_TITLE' | translate"
  [confirmPrompt]="'DIALOG.UNMATCH_TRANSACTION.CONFIRM_PROMPT' | translate"
  [isDeleteAction]="true"
  [trackingScreenName]="trackingScreenName"
  [primaryActionTapped]="unmatchPrimaryButtonTrackingAction"
  [secondaryActionTapped]="unmatchSecondaryButtonTrackingAction"
  [trackingDialogName]="unmatchDialogTrackingObject"
  (onClose)="onUnmatch($event)"
>
</app-confirm-dialog>
